import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ChangeDetectionStrategy
} from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "rask-planeringsstatus-indicator",
    styleUrls: ["./planeringsstatus-indicator.component.scss"],
    templateUrl: "./planeringsstatus-indicator.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class PlaneringsstatusIndicatorComponent implements OnInit, OnChanges {
  @Input() planeringsstatus: string;

  statusClass = "";

  ngOnInit() {
      this.setStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
      if (changes.planeringsstatus && !changes.firstChange) {
          this.planeringsstatus = changes.planeringsstatus.currentValue;
      }
      this.setStatus();
  }

  setStatus() {
      const status = this.getClass();
      this.statusClass = status !== undefined ? status : this.statusClass;
  }

  getClass() {
      switch (this.planeringsstatus) {
          case "Färdigplanerat":
              return "planeringsstatus_fardigplanerat";
          case "Under planering":
              return "planeringsstatus_under-planering";
          case "Tillgängligt":
              return "planeringsstatus_tillgangligt";
          default:
              return "";
      }
  }
}
